import { cn, plur } from 'common/utils'
import {
  UsersIcon,
  DomainReviewsIcon,
  PageReviewsIcon,
  MemberJoinedIcon,
} from 'cc/icons'

export const UserStats = ({ className, user, children }) => {
  if (!user?.meta) {
    console.log('TODO: we need to send stats through to Algolia')
    return null
  }

  const {
    numFollowers = 0,
    numDomainReviews = 0,
    numPageReviews = 0,
    createdAt,
  } = user.meta

  return (
    <div className={cn(className)}>
      <div className="flex flex-wrap">
        {numFollowers > 0 ? (
          <div className="whitespace-nowrap flex items-center mr-4">
            <UsersIcon className="mr-2" />
            {plur(numFollowers, 'follower')}
          </div>
        ) : null}
        {numDomainReviews > 0 ? (
          <div className="whitespace-nowrap flex items-center mr-4">
            <DomainReviewsIcon className="mr-2" />
            {plur(numDomainReviews, 'site review')}
          </div>
        ) : null}
        {numPageReviews > 0 ? (
          <div className="whitespace-nowrap flex items-center mr-4">
            <PageReviewsIcon className="mr-2" />
            {plur(numPageReviews, 'page review')}
          </div>
        ) : null}
        {createdAt ? (
          <div className="whitespace-nowrap flex items-center mr-4">
            <MemberJoinedIcon className="mr-2" />
            Member since {createdAt.toLocaleDateString()}
          </div>
        ) : null}
      </div>
      {children}
    </div>
  )
}

export default UserStats
